import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { BoundedApiError } from '@bounded/api-client';
import { q } from '../api/queries';

/** Route guard: resolves the session or sends the user to sign in, remembering where they were going. */
export async function requireSession(queryClient: QueryClient, href: string) {
  try { return await queryClient.ensureQueryData(q.me()); }
  catch (error) {
    if (error instanceof BoundedApiError && error.status === 401) throw redirect({ to: '/sign-in', search: { next: href } });
    throw error;
  }
}
